import React from "react";
import { styled } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import { FormHelperText } from "@mui/material";
import { useFormContext } from "react-hook-form";

const CustomTextarea = styled("textarea")(({ theme }) => ({
  width: "100%",
  padding: "8px 0", // Padding to give space to the label and text area
  border: "none", // No visible border
  borderBottom: "1px solid #ccc", // Mimics the bottom border like "standard" variant
  fontSize: "14px", // Font size for the textarea
  outline: "none", // Remove default focus outline
  resize: "none", // Disable resizing
  fontFamily: "Inter",
  "&:focus": {
    borderBottom: "2px solid #ccc", // Border color on focus, like in "standard" variant
  },
}));

interface CustomTextAreaProps {
  label: string;
  error: boolean;
  helperText: string;
  name: string;
}

const StandardTextarea: React.FC<CustomTextAreaProps> = ({
  label,
  error,
  helperText,
  name,
}) => {
  const { register } = useFormContext();
  return (
    <div>
      {/* Fixed Label */}
      <InputLabel
        shrink
        sx={{
          fontSize: "14px",
          fontFamily: "Inter",
          fontWeight: "400",
          color: "#969696",
          position:'relative',
          bottom:'7px'
        }}
      >
        {label}
      </InputLabel>

      {/* Regular Textarea */}
      <CustomTextarea
        rows={3.5} // Setting the initial height with rows
        {...register(name)}
        sx={{
          position: "relative",
          bottom: "15px",
          borderBottom: error ? "1px solid red" : "",
          "&:focus": {
            borderBottom: error ?"2px solid #red":"", // Border color on focus, like in "standard" variant
          },
        }}
      />

      {/* Helper Text */}
      <FormHelperText sx={{ color: "red",position:'relative',bottom:'15px' }}>{helperText}</FormHelperText>
    </div>
  );
};

export default StandardTextarea;
